import {getAxios} from '@deviceinsight/ng-ui-api-client';
import {CustomDatapoint} from '../modules/customDatapoints/types';

export const listCustomDatapoints = (assetUrn: string): Promise<CustomDatapoint[]> =>
	getAxios()
		.get(`/rafi/v1/assets/${assetUrn}/customDatapoints`, {params: {size: 10}})
		.then((response) => response.data);

export const createCustomDatapoint = (assetUrn: string, dp: object): Promise<CustomDatapoint> =>
	getAxios()
		.post(`/rafi/v1/assets/${assetUrn}/customDatapoints`, dp)
		.then((response) => response.data);

export const deleteCustomDatapoint = (assetUrn: string, dpId: string): Promise<CustomDatapoint> =>
	getAxios()
		.delete(`/rafi/v1/assets/${assetUrn}/customDatapoints/${dpId}`)
		.then((response) => response.data);

export const updateCustomDatapoint = (assetUrn: string, dpId: string, dp: object): Promise<CustomDatapoint> =>
	getAxios()
		.put(`/rafi/v1/assets/${assetUrn}/customDatapoints/${dpId}`, dp)
		.then((response) => response.data);
